import { tool, zodSchema } from 'ai';
import { z } from 'zod';
import type { AiTool } from '@erikdakoda/ai-tool/types';
import { readAiModelInputSchema } from './aiModelAiToolInputSchemas';
import { aiModelsToolGroupIcon } from './toolGroupIcon';

export { readAiModelInputSchema };

export const readAiModelOutputSchema = z.object({
  aiModel: z
    .unknown()
    .nullable()
    .describe(
      'AI model row or null if not found. Validated full shape when `select` is omitted; otherwise matches expanded flat `select` mask.',
    ),
});

export type ReadAiModelInput = z.infer<typeof readAiModelInputSchema>;
export type ReadAiModelOutput = z.infer<typeof readAiModelOutputSchema>;

export const readAiModel: AiTool<undefined, ReadAiModelInput, ReadAiModelOutput> = {
  id: 'readAiModel',

  group: 'ai-models',

  ...aiModelsToolGroupIcon,

  userSelect: false,

  access: 'READ',

  tool: tool({
    description:
      'Load a single AI model catalog row by id. Omit `select` for the default full catalog mask (pricing, context limits, modalities, features, endpoints, integration provider metadata, and other fields); pass a flat `{ fieldName: true }` mask for specific fields. When `integration` is selected, it includes provider label, icon, and optional subscriptionUSD.',
    inputSchema: zodSchema(readAiModelInputSchema),
    outputSchema: zodSchema(readAiModelOutputSchema),
  }),
};
